import exp from 'constants';
import {SET_USER_REPSITE_DATA,SET_USER_CONFIGURATION_DATA,SET_CREATE_STREAM_DATA,SET_TOKEN_DATA,SET_JOIN_DATA,SET_JOIN_ATTENDEEID_DATA,SET_ATTENDEE_TOKEN,SET_RTM_TOKEN,SET_ALL_ATTENDEE_LIST} from './livemain.actionTypes'
import {SET_SLOW_NETWORK, SET_HOST_SECONDS, SET_HOST_TIME, SET_PERSON_NUM, SET_ATTENDEE_LIST, SET_STREAM_STATE, SET_PRESENTER_NUM,SET_STREAM_WIDTH,SET_STREAM_HEIGHT, SET_INFO_DATA, SET_HOST_CONNECTION_STATUS} from './livemain.actionTypes'

export function setRepsiteData(data:any): any {
    
    return (dispatch: any) => {
        dispatch({
            type: SET_USER_REPSITE_DATA,
            payload:data
        });
    }
}


export function setConfigurationData(data:any): any {
    
    return (dispatch: any) => {
        dispatch({
            type: SET_USER_CONFIGURATION_DATA,
            payload:data
        });
    }
}

export function setCreateStreamData(data:any): any {
    
    return (dispatch: any) => {
        dispatch({
            type: SET_CREATE_STREAM_DATA,
            payload:data
        });
    }
}

export function setTokenData(data:any): any {
    
    return (dispatch: any) => {
        dispatch({
            type: SET_TOKEN_DATA,
            payload:data
        });
    }
}

export function setJoinData(data:any): any {
    
    return (dispatch: any) => {
        dispatch({
            type: SET_JOIN_DATA,
            payload:data
        });
    }
}

export function setInfoData(data:any): any {
    
    return (dispatch: any) => {
        dispatch({
            type: SET_INFO_DATA,
            payload:data
        });
    }
}

export function setJoinAttendeeIDData(data:any): any {
    
    return (dispatch: any) => {
        dispatch({
            type: SET_JOIN_ATTENDEEID_DATA,
            payload:data
        });
    }
}

export function setAttendeeToken(data:any): any {
    
    return (dispatch: any) => {
        dispatch({
            type: SET_ATTENDEE_TOKEN,
            payload:data
        });
    }
}

export function setRTMToken(data:any): any {
    
    return (dispatch: any) => {
        dispatch({
            type: SET_RTM_TOKEN,
            payload:data
        });
    }
}

export function setHostTime(data:any): any {
    
    return (dispatch: any) => {
        dispatch({
            type: SET_HOST_TIME,
            payload:data
        });
    }
}

export function setHostSeconds(data:any): any {
    
    return (dispatch: any) => {
        dispatch({
            type: SET_HOST_SECONDS,
            payload:data
        });
    }
}

export function setSlowNetwork(data:any): any {
    
    return (dispatch: any) => {
        dispatch({
            type: SET_SLOW_NETWORK,
            payload:data
        });
    }
}


export function setPersonNum(data:any): any {
        
        return (dispatch: any) => {
            dispatch({
                type: SET_PERSON_NUM,
                payload:data
            });
        }
    }

    export function setPresenterNum(data:any): any {
        return (dispatch: any) => {
            dispatch({
                type: SET_PRESENTER_NUM,
                payload:data
            });
        }
    }

    export function setStreamWidth(data:any): any {
            
            return (dispatch: any) => {
                dispatch({
                    type: SET_STREAM_WIDTH,
                    payload:data
                });
            }
        }

        export function setStreamHeight(data:any): any {
                
                return (dispatch: any) => {
                    dispatch({
                        type: SET_STREAM_HEIGHT,
                        payload:data
                    });
                }
            }



    export function setAttendeeList(data:any): any {
        
        return (dispatch: any) => {
            dispatch({
                type: SET_ATTENDEE_LIST,
                payload:data
            });
        }
    }    

    export function setAllAttendeeList(data:any): any {
        
        return (dispatch: any) => {
            dispatch({
                type: SET_ALL_ATTENDEE_LIST,
                payload:data
            });
        }
    }

    export function setStramState(data:any): any {
        
        return (dispatch: any) => {
            dispatch({
                type: SET_STREAM_STATE,
                payload:data
            });
        }
    }

    export function setHostConnectionStatus(data:boolean): any {
        return (dispatch: any) => {
            dispatch({
                type: SET_HOST_CONNECTION_STATUS,
                payload:data
            });
        }
    }